import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SUBSCRIPTION_CANCEL_FLOW_PROCESS_API } from '../../constants/central-api';

interface ProcessCancelFlowPayload {
  subscription_id: number | string;
  action_type: string;
}

interface ProcessCancelFlowResponse {
  success?: boolean;
  message?: string;
  data?: any;
}

export default async function process_cancel_flow_action_api_call({
  subscription_id,
  action_type,
}: ProcessCancelFlowPayload): Promise<ProcessCancelFlowResponse | null> {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: SUBSCRIPTION_CANCEL_FLOW_PROCESS_API,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
    body: JSON.stringify({
      subscription_id,
      action_type,
    }),
  };

  const actionType = 'PROCESS_SUBSCRIPTION_CANCEL_FLOW_ACTION';
  const customMsg = 'Cancel flow processed successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data as ProcessCancelFlowResponse | undefined;

  if (res?.actionType === actionType && response) {
    return response;
  }

  return null;
}
